import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class SmartFeedPagination extends BaseOption {
  static optionValues = {
    infiniteScroll: {
      id: "infiniteScroll",
      meta: {
        loadMoreBehavior: "auto",
      },
    },
    clickToPaginate: {
      id: "clickToPaginate",
      meta: {
        loadMoreBehavior: "manual",
      },
    },
    pageNumbers: {
      id: "pageNumbers",
      meta: {
        loadMoreBehavior: "manual",
      },
    },
    linkToViewAllPage: {
      id: "linkToViewAllPage",
      meta: {
        loadMoreBehavior: "none",
      },
    },
    noPagination: {
      id: "noPagination",
      meta: {
        loadMoreBehavior: "none",
      },
    },
  };

  static label = "Pagination Options";

  static userInterfaceComponent = {
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: [
        {
          id: this.optionValues.infiniteScroll,
          name: "Infinite Scroll",
        },
        {
          id: this.optionValues.clickToPaginate,
          name: "Click to Paginate",
        },
        {
          id: this.optionValues.pageNumbers,
          name: "Page Numbers",
        },
        {
          id: this.optionValues.linkToViewAllPage,
          name: "Link to View All Page",
        },
        {
          id: this.optionValues.noPagination,
          name: "No Pagination",
        },
      ],
    },
  };

  static getOptionMetaData(option) {
    if (typeof option === "string") {
      // An unknown key (or a pre-hydration read) must mean "no meta", not a
      // throw — a throw here aborts the whole page's Vue mount.
      return this.optionValues[option]?.meta;
    }
    return option?.meta;
  }

  static listOptionValues() {
    return Object.keys(this.optionValues);
  }

  static defaultValue = this.optionValues.clickToPaginate;
}
